import { inject } from 'vue'
import { RequestService } from './RequestService'

export function UserAccessBulkService() {
  const functionsBaseUrl = inject('functionsBaseUrl')
  const { post, handleErrors } = RequestService()
  const base = `${functionsBaseUrl}/usersGateway/api/v1/users/access/bulk`

  function toServiceError(error, fallback) {
    const payload = error?.response?.data
    const err = new Error(payload?.message || error?.message || fallback)
    err.details = payload?.data
    return err
  }

  async function preview(users) {
    try {
      const response = await post('bulkUserAccessPreview', `${base}/preview`, { users })
      if (!response?.data?.success) {
        throw new Error(response?.data?.message || 'Preview failed')
      }
      return response.data.data
    } catch (error) {
      handleErrors('bulkUserAccessPreview', error)
      throw toServiceError(error, 'Preview failed')
    }
  }

  async function apply(users) {
    try {
      const response = await post('bulkUserAccessApply', base, { users })
      if (!response?.data?.success) {
        throw new Error(response?.data?.message || 'Bulk update failed')
      }
      return response.data.data
    } catch (error) {
      handleErrors('bulkUserAccessApply', error)
      throw toServiceError(error, 'Bulk update failed')
    }
  }

  return { preview, apply }
}
